export const common = {
  langs: ['es', 'ca'],
  defaultLang: 'ca',
  mock: false,

  urlContactoLogin: 'https://innova.gva.es/es/web/universidad/preinscripcion',
  urlAyudaIdesp: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaIDESP_IXESPcas.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AjudaIDESP_IXESPval.pdf'
  },
  urlAyudaTramitadorAcceso: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoCAS_breve.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoVAL_breve.pdf'
  },
  urlAyudaTramitadorAccesoDet: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AyudaTramitadorAccesoCAS_det.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/AjudaTramitadorAccesVAL_det.pdf'
  },
  urlAyudaPriuni: {
    es: 'http://tramitadoredudesa.gva.es:8008/tel/assets/ManualAsistenteSolicitud_cas.pdf',
    ca: 'http://tramitadoredudesa.gva.es:8008/tel/assets/ManualAsistenteSolicitud_val.pdf'
  },
  urlAyudaCondEspeciales: 'http://tramitadoredudesa.gva.es:8008/tel/assets/GradosCondicionesEspeciales.pdf',
  urlAyudaDocRequerida: 'http://tramitadoredudesa.gva.es:8008/tel/assets/DocumentacionRequerida.pdf'
};

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};
